import { createSlice } from '@reduxjs/toolkit';
import { IFormState } from '../../../types/referral/form';
import { getRegions } from '../../../thunks/referral';

const initialState: IFormState = {
  regionsList: [],
};

const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getRegions.fulfilled, (state, action) => {
        state.regionsList = action.payload;
      })
      .addCase(getRegions.rejected, state => {
        state.regionsList = [];
      });
  },
});

export const { reducer: formReducer } = formSlice;
